import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withTrans } from '../i18n/withTrans';
import { isEmbedMode, postEmbedHeight } from '../utils';

const Layout = ({ children }) => {
  useEffect(() => {
    if (!isEmbedMode()) return undefined;

    const originalBodyOverflow = document.body.style.overflow;
    const originalHtmlOverflow = document.documentElement.style.overflow;
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';

    postEmbedHeight();
    window.requestAnimationFrame(postEmbedHeight);

    const resizeObserver =
      typeof ResizeObserver !== 'undefined'
        ? new ResizeObserver(postEmbedHeight)
        : null;

    if (resizeObserver) {
      resizeObserver.observe(document.body);
      resizeObserver.observe(document.documentElement);
      const app = document.getElementById('___gatsby');
      if (app) {
        resizeObserver.observe(app);
      }
    }

    const mutationObserver =
      typeof MutationObserver !== 'undefined'
        ? new MutationObserver(postEmbedHeight)
        : null;

    if (mutationObserver) {
      mutationObserver.observe(document.body, {
        attributes: true,
        childList: true,
        subtree: true,
      });
    }

    window.addEventListener('load', postEmbedHeight);
    window.addEventListener('resize', postEmbedHeight);
    window.addEventListener('click', postEmbedHeight);
    window.addEventListener('input', postEmbedHeight);
    window.addEventListener('transitionend', postEmbedHeight);
    window.addEventListener('animationend', postEmbedHeight);

    const interval = window.setInterval(postEmbedHeight, 500);

    return () => {
      resizeObserver?.disconnect();
      mutationObserver?.disconnect();
      window.removeEventListener('load', postEmbedHeight);
      window.removeEventListener('resize', postEmbedHeight);
      window.removeEventListener('click', postEmbedHeight);
      window.removeEventListener('input', postEmbedHeight);
      window.removeEventListener('transitionend', postEmbedHeight);
      window.removeEventListener('animationend', postEmbedHeight);
      window.clearInterval(interval);
      document.body.style.overflow = originalBodyOverflow;
      document.documentElement.style.overflow = originalHtmlOverflow;
    };
  }, []);

  return <>{children}</>;
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default withTrans(Layout);
